/* eslint-disable consistent-this */

export function debounce(func, delay) {
  let inDebounce
  return function tick(...args) {
    const context = this
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() => func.apply(context, args), delay)
  }
}

export function debounceAsync(func, delay) {
  let debounceTimer;
  return async function() {
    const context = this;
    const args = arguments;
    return new Promise((resolve, reject) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(async () => {
        try {
          const result = await func.apply(context, args);
          resolve(result);
        } catch (error) {
          reject(error);
        }
      }, delay);
    });
  };
}


export function throttle(func, limit) {
  let lastFunc
  let lastRan
  return function tick(...args) {
    const context = this
    if (!lastRan) {
      func.apply(context, args)
      lastRan = Date.now()
    } else {
      clearTimeout(lastFunc)
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args)
          lastRan = Date.now()
        }
      }, limit - (Date.now() - lastRan))
    }
  }
}
